<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="jenis_diklat && jenis_diklat.id ? 'Ubah Jenis Diklat' : 'Setting Peran Diklat: ' + jenis_diklat.keterangan"
  >
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-row wrap class="pa-5" no-gutters>
              <v-col cols="12">
                <span class="primary--text title ml-4">Pemetaan Peran SIM ke LMS</span>
                <div v-for="(peran, index) in jenis_diklat.tab" :key="peran.index" class="pa-2 ma-2 ">
                  <v-row no-gutters>
                    <v-col cols="11">
                      <v-row>
                        <v-col cols="12" sm="12" md="4" lg="4" class="mb-0 pb-0">
                          <v-text-field
                            outlined
                            dense
                            autocomplete="false"
                            name="Label"
                            placeholder="Isikan Label"
                            label="Label"
                            v-model="peran.label"
                            persistent-hint
                            :data-vv-name="'label' + index"
                            data-vv-as="Label"
                            v-validate="'required'"
                            :error-messages="errors.collect('form.label' + index)"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="4" class="mb-0 pb-0">
                          <v-autocomplete
                            outlined
                            dense
                            autocomplete="false"
                            v-model="peran.group"
                            :items="itemPeranSIM"
                            no-data-text="Data Tidak Tersedia"
                            placeholder="Pilih Peran SIM"
                            label="Peran SIM"
                            name="Peran SIM"
                            item-value="id"
                            item-text="keterangan"
                            :data-vv-name="'peran_sim' + index"
                            data-vv-as="Peran SIM"
                            return-object
                            v-validate="'required'"
                            :error-messages="errors.collect('form.peran_sim' + index)"
                          >
                            <template slot="selection" slot-scope="data">
                              <span class="font-weight-bold caption"
                                >{{ data.item.keterangan }} [{{ data.item.id }}]</span
                              >
                            </template>
                            <template slot="jenis_diklat" slot-scope="data">
                              <span class="font-weight-bold caption"
                                >{{ data.item.keterangan }} [{{ data.item.id }}]</span
                              >
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="4" class="mb-0 pb-0">
                          <v-autocomplete
                            outlined
                            dense
                            autocomplete="false"
                            v-model="peran.rolemoodle"
                            :items="itemPeranLMS"
                            no-data-text="Data Tidak Tersedia"
                            placeholder="Pilih Peran LMS"
                            label="Peran LMS"
                            name="Peran LMS"
                            item-value="id"
                            item-text="keterangan"
                            :data-vv-name="'peran_lms' + index"
                            data-vv-as="Peran LMS"
                            return-object
                            v-validate="'required'"
                            :error-messages="errors.collect('form.peran_lms' + index)"
                          >
                            <template slot="selection" slot-scope="data">
                              <span class="font-weight-bold caption"
                                >{{ data.item.keterangan }} [{{ data.item.id }}]</span
                              >
                            </template>
                            <template slot="jenis_diklat" slot-scope="data">
                              <span class="font-weight-bold caption"
                                >{{ data.item.keterangan }} [{{ data.item.id }}]</span
                              >
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="1">
                      <v-row>
                        <v-col cols="12" sm="12" md="1" lg="1" class="mb-0 pb-0">
                          <m-button
                            class="ml-2"
                            small
                            fab
                            icon="mdi-delete"
                            color="error"
                            action="remove"
                            @remove="remove(index)"
                          ></m-button>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" class="text-right">
                <m-button class="ml-n4" small fab icon="mdi-plus" color="info" action="add" @add="add"></m-button
              ></v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      jenis_diklat: {
        tab: []
      },
      defJenisDiklat: {
        tab: []
      },
      itemJenisDiklat: [],
      itemPeranSIM: [],
      itemPeranLMS: [],
      itemMoodles: [],
      alert: ALERT_INFO,
      current_page: 1,
      page: null,
      cp: 1
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.loadJenisDiklat();
      this.loadPeranLMS();
      this.loadPeranSIM();
      this.jenis_diklat = obj ? { ...obj } : { ...this.defJenisDiklat };

      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },
    loadJenisDiklat() {
      return this.$store
        .dispatch("kelola/getJenisDiklat")
        .then(res => {
          this.itemJenisDiklat = res;
        })
        .catch(e => e);
    },
    loadPeranLMS() {
      return this.$store
        .dispatch("kelola/getPeranLMS")
        .then(res => {
          this.itemPeranLMS = res;
        })
        .catch(e => e);
    },
    loadPeranSIM() {
      return this.$store
        .dispatch("kelola/getPeranSIM")
        .then(res => {
          this.itemPeranSIM = res;
        })
        .catch(e => e);
    },
    add() {
      this.jenis_diklat.tab.push({
        jenis_diklat_id: this.jenis_diklat.id,
        group: null,
        rolemoodle: null
      });
    },
    remove(index) {
      this.jenis_diklat.tab.splice(index, 1);
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("kelola/formKelolaPeran", this.jenis_diklat)
            .then(res => {
              this.$refs.dlg.resolve();
              this.$forceUpdate();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}
.vdatetime-input {
  width: 500px;
}
</style>
